import object from '@mailobj-browser/front/js/utils/object.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import click from '@mailobj-browser/front/js/events/types/click.js'
import { scope } from '#components/generics/js/selectors/scope.js'
import local from '#components/app/js/common/storage/local.js'
import { language } from '#components/app/js/common/storage/vars.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'

const onClick = object(listener, {
  type: click,
  passive,
  task: (
    list, { target }
  ) => {
    const anchor = target.closest('a')
    const { lang } = scope(anchor)
    local.set(language, lang)
    const { ownerDocument } = list
    ownerDocument.location.reload()
  }
})

export default elem => {
  onClick.listen(elem)
}
